// extracted by mini-css-extract-plugin
export default {"flex-column":"editPostForm_flex-column__JScMU","flex-row":"editPostForm_flex-row__9X53Z","page-size":"editPostForm_page-size__iNmQ+","save":"editPostForm_save__cwzB1"};